import { onMounted, onUnmounted, ref } from "vue";

export default function useRefetch(operation: () => Promise<void>, frequency: number): void {
  const intervalId = ref<null | ReturnType<typeof setInterval>>(null);
  const abortController = ref(new AbortController());

  onMounted(() => {
    intervalId.value = setInterval(operation, frequency);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        clearInterval(intervalId.value);
        intervalId.value = null;
      } else {
        intervalId.value = setInterval(operation, frequency);
      }
    }, { signal: abortController.value.signal });
  });

  onUnmounted(() => {
    clearInterval(intervalId.value);
    intervalId.value = null;
    abortController.value.abort()
  });
}
